
import React from "react";

const Process = () => {
  const processSteps = [
    {
      title: "Discovery & Strategy Session",
      desc: "A collaborative initial phase focused on understanding your business goals, challenges, operational context, and data readiness. The output is the identification of high-impact AI and automation use cases.",
    },
    {
      title: "AI Roadmap & Proposal",
      desc: "Based on the discovery session, I deliver a formal strategic document. This roadmap outlines the recommended approach, scope of work, project phases, clear deliverables, timelines, and projected ROI.",
    },
    {
      title: "Proof of Concept (PoC) / Pilot Project",
      desc: "To build momentum and validate the approach with minimal risk, we will begin with a small-scale, quick-win project. This demonstrates value quickly and builds the internal case for a larger investment.",
    },
    {
      title: "MVP Development & Integration",
      desc: "Following a successful PoC, the core solution (Minimum Viable Product) is developed and, crucially, integrated into your existing workflows and systems.",
    },
    {
      title: "Scaling & Ongoing Optimization",
      desc: "Post-deployment, my service transitions to expanding the solution across the enterprise and providing long-term support, performance monitoring, and continuous optimization to ensure lasting value.",
    },
  ];

  return (
    <section id="process" className="section">
      <div className="container">
        <p className="text-center mb-2 wow fadeInUp">
          <span className="bg-primary text-dark px-2">Process</span>
        </p>
        <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">
          How I Work
        </h2>
        <div className="row">
          {processSteps.map((step, index) => (
            <div className="col-md-12" key={index}>
              <div className="d-flex">
                <div className="me-4 text-primary fw-bold fs-1">{index + 1}</div>
                <div>
                  <h3 className="text-6 fw-600 mb-3">{step.title}</h3>
                  <p className="text-muted">{step.desc}</p>
                </div>
              </div>
              {index < processSteps.length - 1 && <hr className="my-4" />}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
